export const getOriginNoTrailingDot = () => {
  if (typeof window === 'undefined') return ''
  const host = window.location.host.replace(/\.$/, '')
  return `${window.location.protocol}//${host}`
}
